'use client';

import { HeroUIProvider as Provider } from '@heroui/react';
import type * as React from 'react';

export function HeroUIProvider({ children }: { children: React.ReactNode }) {
  return <Provider>{children}</Provider>;
}
